module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paytitle":["Offering a dynamic conversion of ","Currency, tip acceptance and ","and other services that will advance ","your business."]},"es":{"paytitle":["Ofrece conversión dinámica de ","moneda, la aceptación de propinas ","y otros servicios que harán crecer tu ","negocio."]}}')
  delete Component.options._Ctor
}
